import React from 'react';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import AuthRoute from './AuthRoute';
import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import DashboardLayout from 'layouts/dashboard.layout';
import ItemRequests from 'pages/main-store/item-requests';
import ExcessReturns from 'pages/main-store/excess-returns';
import WasteReport from 'pages/main-store/waste-report';
import Vendors from 'pages/main-store/vendors';
import ProcurementList from 'pages/main-store/procurements/procurement-list';
import InventoryStockItems from 'pages/main-store/inventory-stock';
import InventoryStockLayout from 'layouts/inventory.stock.layout';
import InventoryRequestPreview from 'pages/main-store/inventory-stock/inventory-stock-bulk-edit/inventory-request/preview';
import InventoryRequest from 'pages/main-store/inventory-stock/inventory-stock-bulk-edit/inventory-request';
import VendorsLayout from 'layouts/vendors.layout';
import BrandChefsLayout from 'layouts/brand-chefs.layout';
import VendorProfile from 'pages/main-store/vendors/vendor-profile';
import AddVendor from 'pages/main-store/vendors/add-vendor';
import NewProcurement from 'pages/main-store/procurements/new-procurement';
import ItemRequestDetails from 'pages/main-store/item-requests/item-request-details';
import EditVendorDetails from 'pages/main-store/vendors/vendor-profile/edit-vendor-details';
import InventoryStockBulkEdit from 'pages/main-store/inventory-stock/inventory-stock-bulk-edit';
import InventoryStoreLayout from 'layouts/inventory.store.layout';
import PricingLayout from 'layouts/pricing.layout';
import UpdateProcurement from 'pages/main-store/procurements/update-procurement';
import ReviewItemRequestDetails from 'pages/main-store/item-requests/review-item-request-details';
import ExcessReturnsDetails from 'pages/main-store/excess-returns/excess-returns-details';
import EditVendorStoreItems from 'pages/main-store/vendors/vendor-profile/edit-vendor-store-items';
import ProcurementLayout from 'layouts/procurement.layout';
import UpdateProcurementDetails from 'pages/main-store/procurements/update-procurement-details';
import ConversionList from 'pages/main-store/brand-chefs/manage-meals';
import AddConversionList from 'pages/main-store/brand-chefs/manage-meals/add-manage-meals';
import ManageRequests from 'pages/main-store/brand-chefs/manage-requests';
import UpdateRejectedProcurement from 'pages/main-store/procurements/update-rejected-procurement.tsx';
import InventoryStockEdit from 'pages/main-store/inventory-stock/inventory-stock-edit';

import InventoryStoreItems from 'pages/main-store/inventory-store-items';
import InventoryStoreItemEdit from 'pages/main-store/inventory-store-items/inventory-store-items-edit';
import StoreItemRequest from 'pages/main-store/inventory-store-items/store-item-request';
import BulkEditStoreItems from 'pages/main-store/inventory-store-items/inventory-store-items-bulk-edit';
import ItemRequestLayout from 'layouts/item-request.layout';
import RequestConversionList from 'pages/main-store/brand-chefs/manage-meals/request-manage-meals';
import IngredientList from 'pages/main-store/pricing/ingredient-list';
import Configuration from 'pages/main-store/pricing/configuration';
import AddConfiguration from 'pages/main-store/pricing/configuration/add-configuration';
import PaymentTrackerDetails from 'pages/main-store/payment-tracker/payment-tracker-details';
import PaymentTracker from 'pages/main-store/payment-tracker';
import PaymentTrackerLayout from 'layouts/payment-tracker.layout';
import BaseMeals from 'pages/main-store/pricing/base-meals';
import EditBaseMeals from 'pages/main-store/pricing/base-meals/edit-base-meals';
import ProductionReport from 'pages/kitchen/production-report';
import ProductionReportLayout from 'layouts/kitchen/production-report.layout';
import EditMeal from 'pages/kitchen/production-report/edit-meal';
import UpdateMeals from 'pages/kitchen/production-report/update-meals';
import AddMeal from 'pages/kitchen/production-report/add-meal';
import ReviewMealDetails from 'pages/kitchen/production-report/add-meal/review-meal-details';
import KitchenInventoryStockItems from 'pages/kitchen/inventory-stock';
import KitchenInventoryRequest from 'pages/kitchen/inventory-stock/inventory-stock-bulk-edit/inventory-request';
import KitchenInventoryRequestPreview from 'pages/kitchen/inventory-stock/inventory-stock-bulk-edit/inventory-request/preview';
import KitchenInventoryStockBulkEdit from 'pages/kitchen/inventory-stock/inventory-stock-bulk-edit';
import KitchenInventoryStockEdit from 'pages/kitchen/inventory-stock/inventory-stock-edit';
import KitchenInventoryStockLayout from 'layouts/kitchen/inventory.stock.layout';
import KitchenProcurementLayout from 'layouts/kitchen/procurement.layout';
import KitchenProcurementList from 'pages/kitchen/internal-procurement/procurement-list';
import KitchenNewProcurement from 'pages/kitchen/internal-procurement/new-procurement';
import KitchenUpdateProcurement from 'pages/kitchen/internal-procurement/update-procurement';
import KitchenUpdateProcurementDetails from 'pages/kitchen/internal-procurement/update-procurement-details';
import KitchenUpdateRejectedProcurement from 'pages/kitchen/internal-procurement/update-rejected-procurement.tsx';
import KitchenWasteReport from 'pages/kitchen/waste-report';
import KitchenItemRequests from 'pages/kitchen/item-requests';
import KitchenReviewItemRequestDetails from 'pages/kitchen/item-requests/review-item-request-details';
import KitchenExcessReturns from 'pages/kitchen/excess-returns';
import KitchenExcessReturnsDetails from 'pages/kitchen/excess-returns/excess-returns-details';
import InventoryStockExcessReturns from 'pages/kitchen/inventory-stock/inventory-stock-excess-returns';
import ExcessReturnLayout from 'layouts/excess-return.layout';
import SettingsLayout from 'layouts/settings.layout';
import ManageUsers from 'pages/settings/manage-users';
import AddUsers from 'pages/settings/manage-users/add-user';
import EditUsers from 'pages/settings/manage-users/edit-user';
import ManageRoles from 'pages/settings/manage-roles';
import ExecutiveProcurement from 'pages/executives/procurement';
import ExecutiveUpdateProcurement from 'pages/executives/procurement/update-procurement';
import ExecutiveLayout from 'layouts/executive.layout';
import CostSettings from 'pages/main-store/pricing/cost-settings';
import MealsPricing from 'pages/main-store/pricing/meal-pricing';
import EditMealsPricing from 'pages/main-store/pricing/meal-pricing/edit-meal-pricing';
import EditRequest from 'pages/main-store/brand-chefs/manage-requests/edit-request';
import KitchenItemRequestLayout from 'layouts/kitchen/item-request.layout';
import KitchenExcessReturnLayout from 'layouts/kitchen/excess-return.layout';
import GeneralStore from 'pages/general-store';
import SingleStoreDetails from 'pages/single-store-details';
import Dashboard from 'pages/dashboard';
import Profile from 'pages/profile';
import PrepTeamLayout from 'layouts/prep-team-request.layout';
import PrepConversionList from 'pages/prep-team/prep-conversion-list';
import NewKitchenRequest from 'pages/prep-team/kitchen-request/new-kitchen-request';
import KitchenRequestList from 'pages/prep-team/kitchen-request/kitchen-request-list';
import UpdateKitchenRequest from 'pages/prep-team/kitchen-request/update-kitchen-request';
import UpdateKitchenRequestDetails from 'pages/prep-team/kitchen-request/update-kitchen-request-details';

import TransferList from 'pages/main-store/transfer/transfer-list';
import TransferRequestDetails from 'pages/main-store/transfer/transfer-request-details';
import NewTransferRequest from 'pages/main-store/transfer/new-transfer-request';
import UpdateTransferRequest from 'pages/main-store/transfer/update-transfer-request';
import PrepInventoryStockItems from 'pages/kitchen/inventory-prep-items';
import TransferLayout from 'layouts/transfer.layout';
import PrepRequestLayout from 'layouts/prep-team-request.layout';
import PrepReport from 'components/base/prep-report';
import CompletedRequest from 'pages/shared/completed-request';
import ReturnItem from 'pages/main-store/item-requests/item-request-details/return-items';
import ReceiveItem from 'pages/main-store/item-requests/item-request-details/receive-items';
import ReceiveItems from 'pages/main-store/procurements/update-procurement/receive-items';
import ReturnItems from 'pages/main-store/procurements/update-procurement/return-items';
import ReceivePrepItems from 'pages/prep-team/kitchen-request/update-kitchen-request/receive-prep-items';
import KitchenMinimumStockSettings from 'pages/minimum-stock-settings/kitchen-store';
import BrandChefStock from 'pages/kitchen/brand-chef-stock';

const INVENTORY_STORE_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <InventoryStoreItems />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.INVENTORY_STORE_ITEMS_EDIT,
    element: <InventoryStoreItemEdit />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.INVENTORY_STORE_ITEMS_ADD,
    element: <StoreItemRequest />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.INVENTORY_STORE_ITEMS_BULK_EDIT,
    element: <BulkEditStoreItems />
  }
];

const INVENTORY_STOCK_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <Navigate to='main-store' replace />
  },
  {
    path: ':storeType',
    element: <InventoryStockItems />
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.INVENTORY_REQUESTS,
    element: <InventoryRequest />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.INVENTORY_STOCK_BULK_EDIT,
    element: <InventoryStockBulkEdit />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.INVENTORY_REQUESTS_PREVIEW,
    element: <InventoryRequestPreview />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.INVENTORY_STOCK_EDIT,
    element: <InventoryStockEdit />
  }
];

const GENERAL_STORE_DASHBOARD_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <GeneralStore />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.STORE_BY_ID,
    element: <SingleStoreDetails />
  }
];

const PROCUREMENT_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <ProcurementList />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.NEW_PROCUREMENT,
    element: <NewProcurement />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.PROCUREMENT_UPDATE,
    element: <UpdateProcurement />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.PROCUREMENT_REQUEST_RECEIVE_ITEMS,
    element: <ReceiveItems />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.PROCUREMENT_REQUEST_RETURN_ITEMS,
    element: <ReturnItems />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.PROCUREMENT_DETAILS_UPDATE,
    element: <UpdateProcurementDetails />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.PROCUREMENT_UPDATE_REJECTED,
    element: <UpdateRejectedProcurement />
  }
];

const KITCHEN_MANAGE_PREP_TEAM_REQUESTS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <KitchenRequestList />
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.PROCUREMENT_UPDATE,
    element: <UpdateKitchenRequest />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.RECEIVE_PREP_ITEMS,
    element: <UpdateKitchenRequest />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.COMPLETE_PREP_REQUEST,
    element: <CompletedRequest />
  }
];

const PREP_REQUEST_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <KitchenRequestList />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.NEW_PROCUREMENT,
    element: <NewKitchenRequest />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.PROCUREMENT_UPDATE,
    element: <UpdateKitchenRequest />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.PROCUREMENT_DETAILS_UPDATE,
    element: <UpdateKitchenRequestDetails />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.RECEIVE_PREP_ITEMS,
    element: <ReceivePrepItems />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.PREP_REQUEST_REPORT,
    element: <PrepReport />
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.PROCUREMENT_UPDATE_REJECTED,
    element: <UpdateRejectedProcurement />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.PROCUREMENT_COMPLETED,
    element: <CompletedRequest />
  }
];

const VENDOR_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <Vendors />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.VENDOR_PROFILE,
    element: <VendorProfile />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.ADD_VENDOR,
    element: <AddVendor />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.EDIT_VENDOR_DETAILS,
    element: <EditVendorDetails />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.EDIT_VENDOR_STORE_ITEMS,
    element: <EditVendorStoreItems />
  }
];

const MANAGE_MEALS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <ConversionList />
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.ADD_MANAGE_MEALS,
    element: <AddConversionList />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.EDIT_MANAGE_MEALS,
    element: <AddConversionList />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.REQUEST_MANAGE_MEALS,
    element: <RequestConversionList />
  }
];

const INGREDIENT_LIST_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <IngredientList />
  }
];

const EXCEL_MEAL_CONFIGURATION_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <Configuration />
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.ADD_MEALS_CONFIGURATION,
    element: <AddConfiguration />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.EDIT_MEALS_CONFIGURATION,
    element: <AddConfiguration />
  }
];
const EXCEL_PREP_CONFIGURATION_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <PrepConversionList />
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.ADD_MEALS_CONFIGURATION,
    element: <AddConfiguration />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.EDIT_MEALS_CONFIGURATION,
    element: <AddConfiguration />
  }
];

const BASE_MEALS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <BaseMeals />
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.UPDATE_BASE_MEALS,
    element: <EditBaseMeals />
  }
];

const COST_SETTINGS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <CostSettings />
  }
];
const EXCEL_MEAL_PRICING_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <MealsPricing />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.UPDATE_MEALS_PRICING,
    element: <EditMealsPricing />
  }
];

const MANAGE_REQUESTS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <ManageRequests />
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.REVIEW_REQUEST,
    element: <AddConversionList />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.EDIT_REQUEST,
    element: <EditRequest />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.RECEIVE_PREP_ITEMS,
    element: <ReceivePrepItems />
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.MANAGE_REQUESTS_REPORT,
    element: <AddConversionList />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.REQUEST_MANAGE_MEALS,
    element: <RequestConversionList />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.BRAND_CHEF_REQUEST_REPORT,
    element: <PrepReport />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.COMPLETE_BRAND_CHEF_REQUEST,
    element: <CompletedRequest />
  }
  //here
];

const ITEM_REQUEST_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <ItemRequests />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.MANAGE_ITEM_REQUESTS_DETAILS,
    element: <ItemRequestDetails />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.MAIN_STORE_REQUEST_RETURN_ITEMS,
    element: <ReturnItem />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.MAIN_STORE_REQUEST_RECEIVE_ITEMS,
    element: <ReceiveItem />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.REVIEW_ITEM_REQUESTS_DETAILS,
    element: <ReviewItemRequestDetails />
  }
];

const PAYMENT_TRACKER_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <PaymentTracker />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.PAYMNET_TRACKER_UPDATE,
    element: <PaymentTrackerDetails />
  }
];

const EXCESS_RETURNS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <ExcessReturns />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.EXCESS_RETURNS_DETAILS,
    element: <ExcessReturnsDetails />
  }
];

const PREP_TEAM_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <Dashboard />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.PREP_REQUESTS,
    element: (
      <AuthRoute>
        <PrepRequestLayout />
      </AuthRoute>
    ),
    children: PREP_REQUEST_ROUTES
  }
];

const DASHBOARD_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <GeneralStore />
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.GENERAL_STORE_DASHBOARD,
    element: (
      <AuthRoute>
        <Outlet />
      </AuthRoute>
    ),
    children: GENERAL_STORE_DASHBOARD_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.INVENTORY_STOCK,
    element: (
      <AuthRoute>
        <InventoryStockLayout />
      </AuthRoute>
    ),
    children: INVENTORY_STOCK_ROUTES
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.INVENTORY_STORE_ITEMS,
    element: (
      <AuthRoute>
        <InventoryStoreLayout />
      </AuthRoute>
    ),
    children: INVENTORY_STORE_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.PREP_TEAM,
    element: (
      <AuthRoute>
        <PrepTeamLayout />
      </AuthRoute>
    ),
    children: PREP_TEAM_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.PROCUREMENT,
    element: (
      <AuthRoute>
        <ProcurementLayout />
      </AuthRoute>
    ),
    children: PROCUREMENT_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.WASTE_REPORT,
    element: (
      <AuthRoute>
        <WasteReport />
      </AuthRoute>
    )
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.VENDORS,
    element: (
      <AuthRoute>
        <VendorsLayout />
      </AuthRoute>
    ),
    children: VENDOR_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.MANAGE_MEALS,
    element: (
      <AuthRoute>
        <BrandChefsLayout />
      </AuthRoute>
    ),
    children: MANAGE_MEALS_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.ITEM_REQUESTS,
    element: (
      <AuthRoute>
        <ItemRequestLayout />
      </AuthRoute>
    ),
    children: ITEM_REQUEST_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.EXCESS_RETURNS,
    element: (
      <AuthRoute>
        <ExcessReturnLayout />
      </AuthRoute>
    ),
    children: EXCESS_RETURNS_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.MANAGE_REQUESTS,
    element: (
      <AuthRoute>
        <BrandChefsLayout />
      </AuthRoute>
    ),
    children: MANAGE_REQUESTS_ROUTES
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.INGREDIENT_LIST,
    element: (
      <AuthRoute>
        <InventoryStoreLayout />
      </AuthRoute>
    ),
    children: INGREDIENT_LIST_ROUTES
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.EXCEL_MEAL_CONFIGURATION,
    element: (
      <AuthRoute>
        <PricingLayout />
      </AuthRoute>
    ),
    children: EXCEL_MEAL_CONFIGURATION_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.EXCEL_PREP_CONFIGURATION,
    element: (
      <AuthRoute>
        <PricingLayout />
      </AuthRoute>
    ),
    children: EXCEL_PREP_CONFIGURATION_ROUTES
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.BASE_MEALS,
    element: (
      <AuthRoute>
        <PricingLayout />
      </AuthRoute>
    ),
    children: BASE_MEALS_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.COST_SETTINGS,
    element: (
      <AuthRoute>
        <PricingLayout />
      </AuthRoute>
    ),
    children: COST_SETTINGS_ROUTES
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.EXCEL_MEAL_PRICING,
    element: (
      <AuthRoute>
        <PricingLayout />
      </AuthRoute>
    ),
    children: EXCEL_MEAL_PRICING_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.PAYMNET_TRACKER,
    element: (
      <AuthRoute>
        <PaymentTrackerLayout />
      </AuthRoute>
    ),
    children: PAYMENT_TRACKER_ROUTES
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.PROFILE,
    element: (
      <AuthRoute>
        <Profile />
      </AuthRoute>
    )
  }
];

const KITCHEN_PRODUCTION_REPORT_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <ProductionReport />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_EDIT_COKITCHEN_ITEM,
    element: <EditMeal />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_UPDATE_PORTIONS,
    element: <UpdateMeals />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_ADD_MEAL,
    element: <AddMeal />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_REVIEW_MEAL,
    element: <ReviewMealDetails />
  }
];

const KITCHEN_PROCUREMENT_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <KitchenProcurementList />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_NEW_PROCUREMENT,
    element: <KitchenNewProcurement />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_PROCUREMENT_UPDATE,
    element: <KitchenUpdateProcurement />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_PROCUREMENT_DETAILS_UPDATE,
    element: <KitchenUpdateProcurementDetails />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_PROCUREMENT_UPDATE_REJECTED,
    element: <KitchenUpdateRejectedProcurement />
  }
];
const TRANSFER_CHILDREN_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <TransferList />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_NEW_PROCUREMENT,
    element: <NewTransferRequest />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_PROCUREMENT_UPDATE,
    element: <UpdateTransferRequest />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_PROCUREMENT_DETAILS_UPDATE,
    element: <TransferRequestDetails />
  }
];

const TRANSFER_ROUTES: RouteObject[] = [
  {
    path: '',
    element: <TransferLayout />,
    children: TRANSFER_CHILDREN_ROUTES
  }
];

const MANAGE_USERS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <ManageUsers />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.MANAGE_USERS_ADD_USERS,
    element: <AddUsers />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.MANAGE_USERS_EDIT_USERS,
    element: <EditUsers />
  }
];

const MANAGE_ROLES_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <ManageRoles />
  }
];

const SETTINGS_ROUTES = [
  {
    index: true,
    element: <Dashboard />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.MANAGE_USERS,
    element: (
      <AuthRoute>
        <SettingsLayout />
      </AuthRoute>
    ),
    children: MANAGE_USERS_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.MANAGE_ROLES,
    element: (
      <AuthRoute>
        <SettingsLayout />
      </AuthRoute>
    ),
    children: MANAGE_ROLES_ROUTES
  }
];

const EXECUTIVE_PROCUREMENT_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <ExecutiveProcurement />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.EXECUTIVE_UPDATE_PROCUREMENT,
    element: <ExecutiveUpdateProcurement />
  }
];

const KITCHEN_INVENTORY_STOCK_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <Navigate to='kitchen-store' replace />
  },
  {
    path: ':storeType',
    element: <KitchenInventoryStockItems />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_INVENTORY_REQUESTS,
    element: <KitchenInventoryRequest />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_INVENTORY_STOCK_BULK_EDIT,
    element: <KitchenInventoryStockBulkEdit />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_INVENTORY_STOCK_EXCESS_RETURNS,
    element: <InventoryStockExcessReturns />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_INVENTORY_REQUESTS_PREVIEW,
    element: <KitchenInventoryRequestPreview />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_INVENTORY_STOCK_EDIT,
    element: <KitchenInventoryStockEdit />
  }
];

const KITCHEN_PREP_TEAM_STOCK_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <Navigate to='prep-store' replace />
  },
  {
    path: ':storeType',
    element: <PrepInventoryStockItems />
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_INVENTORY_REQUESTS,
    element: <KitchenInventoryRequest />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_INVENTORY_STOCK_BULK_EDIT,
    element: <KitchenInventoryStockBulkEdit />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_INVENTORY_STOCK_EXCESS_RETURNS,
    element: <InventoryStockExcessReturns />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_INVENTORY_REQUESTS_PREVIEW,
    element: <KitchenInventoryRequestPreview />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_INVENTORY_STOCK_EDIT,
    element: <KitchenInventoryStockEdit />
  }
];

const KITCHEN_ITEM_REQUEST_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <KitchenItemRequests />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_MANAGE_ITEM_REQUESTS_DETAILS,
    element: <KitchenReviewItemRequestDetails />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_MANAGE_ITEM_SENT_DETAILS,
    element: <KitchenReviewItemRequestDetails />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_REVIEW_ITEM_REQUESTS_DETAILS,
    element: <KitchenReviewItemRequestDetails />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_MANAGE_ITEM_COMPLETED,
    element: <CompletedRequest />
  }
];

const KITCHEN_EXCESS_RETURNS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <KitchenExcessReturns />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_MANAGE_EXCESS_RETURNS_DETAILS,
    element: <KitchenExcessReturnsDetails />
  }
];

const EXECUTIVE_ROUTES = [
  {
    index: true,
    element: <Dashboard />
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.EXECUTIVE_PROCUREMENTS,
    element: (
      <AuthRoute>
        <ExecutiveLayout />
      </AuthRoute>
    ),
    children: EXECUTIVE_PROCUREMENT_ROUTES
  }
];

const KITCHEN_DASHBOARD_ROUTES = [
  {
    index: true,
    element: <Dashboard />
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_PRODUCTION_REPORT,
    element: (
      <AuthRoute>
        <ProductionReportLayout />
      </AuthRoute>
    ),
    children: KITCHEN_PRODUCTION_REPORT_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_INVENTORY_STOCK,
    element: (
      <AuthRoute>
        <KitchenInventoryStockLayout />
      </AuthRoute>
    ),
    children: KITCHEN_INVENTORY_STOCK_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.STOCK_PREP_TEAM,
    element: (
      <AuthRoute>
        <KitchenInventoryStockLayout />
      </AuthRoute>
    ),
    children: KITCHEN_PREP_TEAM_STOCK_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.STOCK_BRAND_CHEF_TEAM,
    element: <BrandChefStock />
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_PROCUREMENT,
    element: (
      <AuthRoute>
        <KitchenProcurementLayout />
      </AuthRoute>
    ),
    children: KITCHEN_PROCUREMENT_ROUTES
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_WASTE_REPORT,
    element: (
      <AuthRoute>
        <KitchenWasteReport />
      </AuthRoute>
    )
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_MANAGE_ITEM_REQUESTS,
    element: (
      <AuthRoute>
        <KitchenItemRequestLayout />
      </AuthRoute>
    ),
    children: KITCHEN_ITEM_REQUEST_ROUTES
  },

  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_MANAGE_EXCESS_RETURNS,
    element: (
      <AuthRoute>
        <KitchenExcessReturnLayout />
      </AuthRoute>
    ),
    children: KITCHEN_EXCESS_RETURNS_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_MANAGE_PREP_TEAM_REQUESTS,
    element: (
      <AuthRoute>
        <PrepRequestLayout />
      </AuthRoute>
    ),
    children: KITCHEN_MANAGE_PREP_TEAM_REQUESTS_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_MINIMUM_STOCK_SETTINGS,
    element: (
      <AuthRoute>
        <KitchenMinimumStockSettings />
      </AuthRoute>
    )
  },
  {
    path: '*',
    element: <ProductionReport />
  }
];
const MAIN_STORE_ROUTES = [
  {
    path: MAIN_STORE_ROUTE_KEYS.DASHBOARD,
    element: (
      <AuthRoute>
        <DashboardLayout />
      </AuthRoute>
    ),
    children: DASHBOARD_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.DASHBOARD,
    element: (
      <AuthRoute>
        <DashboardLayout />
      </AuthRoute>
    ),
    children: KITCHEN_DASHBOARD_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.TRANSFER,
    element: (
      <AuthRoute>
        <DashboardLayout />
      </AuthRoute>
    ),
    children: TRANSFER_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.KITCHEN_TRANSFER,
    element: (
      <AuthRoute>
        <DashboardLayout />
      </AuthRoute>
    ),
    children: TRANSFER_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.DASHBOARD,
    element: (
      <AuthRoute>
        <DashboardLayout />
      </AuthRoute>
    ),
    children: SETTINGS_ROUTES
  },
  {
    path: MAIN_STORE_ROUTE_KEYS.DASHBOARD,
    element: (
      <AuthRoute>
        <DashboardLayout />
      </AuthRoute>
    ),
    children: EXECUTIVE_ROUTES
  }
];

export default MAIN_STORE_ROUTES;
